import { render, staticRenderFns } from "./CollectionPerformance.vue?vue&type=template&id=6d385ea0&scoped=true&"
import script from "./CollectionPerformance.vue?vue&type=script&lang=js&"
export * from "./CollectionPerformance.vue?vue&type=script&lang=js&"
import style0 from "./CollectionPerformance.vue?vue&type=style&index=0&id=6d385ea0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d385ea0",
  null
  
)

export default component.exports